export const WEBSOCKET__CHAT_MESSAGE_UPDATED =
  "WEBSOCKET__CHAT_MESSAGE_UPDATED";
export const WEBSOCKET__PARTIAL_CHAT_COMPLETION_RECEIVED =
  "WEBSOCKET__PARTIAL_CHAT_COMPLETION_RECEIVED";
export const WEBSOCKET__ACCOUNT_UPDATED = "WEBSOCKET__ACCOUNT_UPDATED";
